"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGmailDarkSafeBrandColor = getGmailDarkSafeBrandColor;
exports.getOrgFacingEmailTheme = getOrgFacingEmailTheme;
exports.resolveEmailThemeTokens = resolveEmailThemeTokens;
const colors_1 = require("./colors");
function getGmailDarkSafeBrandColor(brandHex) {
    const { h, s } = (0, colors_1.getHSLFromHex)(brandHex);
    if (s < 3) {
        return brandHex;
    }
    return (0, colors_1.hslToHex)((0, colors_1.hsl)(h, 55, 78));
}
function getOrgFacingEmailTheme() {
    return {
        canvas: "#EFF2F7",
        cardBg: "#FFFFFF",
        headerText: "#0F0E5B",
        subtitleText: "#2A2AC4",
        bodyText: "#0F0E5B",
        brandFilledBg: "#5555E7",
        brandFilledText: "#FFFFFF",
        outlineBg: "#FFFFFF",
        outlineBorder: "#BFBFFF",
        outlineText: "#2A2AC4",
        link: "#5555E7",
        linkHover: "#2A2AC4",
        footerBg: "#1B1BB5",
        footerText: "#FFFFFF",
        footerAccent: "#84E7D7",
        footerCopyright: "#BFBFFF",
        bannerTitleText: "#FFFFFF",
        bannerAccentText: "#84E7D7",
        viewInBrowser: "#C0C0D4",
        dividerNeutral: "#E5E5EE",
        dividerBrand: "#E9E9FF",
        tModerate: "#0F0E5B",
        tBrand: "#5555E7",
        bSupershy: "#E4E7EC",
    };
}
function resolveEmailThemeTokens(brandColorHex, mode) {
    const { h: baseHue } = (0, colors_1.getHSLFromHex)(brandColorHex);
    const dull = (0, colors_1.isDullMode)(brandColorHex);
    const palette = dull
        ? mode === "dark"
            ? (0, colors_1.getDullDarkPalette)()
            : (0, colors_1.getDullPalette)()
        : mode === "dark"
            ? (0, colors_1.getDarkPalette)(baseHue)
            : (0, colors_1.getLightPalette)(baseHue);
    const f = palette.forms;
    const hex = colors_1.hslToHex;
    const tIntense = hex(f.text.intense);
    const tModerate = hex(f.text.moderate);
    const tBrand = hex(f.text.brand);
    const tQuiet = hex(f.text.quiet);
    const tSupershy = hex(f.text.supershy);
    const tReverse = hex(f.text.reverse);
    const sIntense = hex(f.surface.intense);
    const sModerate = hex(f.surface.moderate);
    const sQuiet = hex(f.surface.quiet);
    const sSupershy = hex(f.surface.supershy);
    const sReverse = hex(f.surface.reverse);
    const shIntense = hex(f.surface.hover.intense);
    const shModerate = hex(f.surface.hover.moderate);
    const shQuiet = hex(f.surface.hover.quiet);
    const bBrand = hex(f.border.brand);
    const bIntense = hex(f.border.intense);
    const bModerate = hex(f.border.moderate);
    const bQuiet = hex(f.border.quiet);
    const bSupershy = hex(f.border.supershy);
    if (mode === "dark" && dull) {
        return {
            tIntense,
            tModerate,
            tBrand,
            tQuiet,
            tSupershy,
            tReverse,
            tError: "#ff8a90",
            sIntense,
            sModerate,
            sQuiet,
            sSupershy,
            sReverse,
            shIntense,
            shModerate,
            shQuiet,
            bBrand,
            bIntense,
            bModerate,
            bQuiet,
            bSupershy,
            canvas: hex((0, colors_1.hsl)(0, 0, 0)),
            emailBg: hex((0, colors_1.hsl)(0, 0, 8)),
            headerBg: hex((0, colors_1.hsl)(0, 0, 14)),
            innerBg: hex((0, colors_1.hsl)(0, 0, 14)),
            noteBg: hex((0, colors_1.hsl)(0, 0, 18)),
            orderBg: hex((0, colors_1.hsl)(0, 0, 16)),
            ctaBg: tIntense,
            ctaBgHover: tModerate,
            ctaText: tReverse,
            brandFill: tIntense,
            brandFillText: tReverse,
            tOrderNumber: tBrand,
            bSecondaryCta: bModerate,
            secondaryCtaBg: sSupershy,
            secondaryCtaBorder: bBrand,
            secondaryCtaText: tIntense,
            calendarBlockBg: hex((0, colors_1.hsl)(0, 0, 18)),
            calendarBlockBorder: hex((0, colors_1.hsl)(0, 0, 30)),
            isDark: true,
            zeffyLogoVariant: "dark",
            footerBg: hex((0, colors_1.hsl)(0, 0, 8)),
            footerText: tModerate,
            footerStrong: tIntense,
        };
    }
    if (mode === "dark") {
        const ribbonFill = getGmailDarkSafeBrandColor(brandColorHex);
        const ribbonText = (0, colors_1.getTextColorOfHexColor)(ribbonFill) === "black" ? "#101010" : "#FFFFFF";
        const ctaFill = hex((0, colors_1.hsl)(baseHue, 80, 72));
        const ctaFillHover = hex((0, colors_1.hsl)(baseHue, 80, 64));
        const ctaFillText = "#000000";
        const secondaryBgMid = hex((0, colors_1.hsl)(baseHue, 20, 46));
        const secondaryTextMid = (0, colors_1.getTextColorOfHexColor)(secondaryBgMid) === "black" ? "#101010" : "#FFFFFF";
        const borderMid = hex((0, colors_1.hsl)(baseHue, 25, 50));
        const borderBrandMid = hex((0, colors_1.hsl)(baseHue, 55, 55));
        return {
            tIntense,
            tModerate,
            tBrand,
            tQuiet,
            tSupershy,
            tReverse,
            tError: "#ff8a90",
            sIntense,
            sModerate,
            sQuiet,
            sSupershy,
            sReverse,
            shIntense,
            shModerate,
            shQuiet,
            bBrand: borderBrandMid,
            bIntense,
            bModerate: borderMid,
            bQuiet,
            bSupershy: borderMid,
            canvas: sIntense,
            emailBg: sQuiet,
            headerBg: sSupershy,
            innerBg: sSupershy,
            noteBg: sSupershy,
            orderBg: sSupershy,
            ctaBg: ctaFill,
            ctaBgHover: ctaFillHover,
            ctaText: ctaFillText,
            brandFill: ribbonFill,
            brandFillText: ribbonText,
            tOrderNumber: tBrand,
            bSecondaryCta: borderMid,
            secondaryCtaBg: secondaryBgMid,
            secondaryCtaBorder: borderBrandMid,
            secondaryCtaText: secondaryTextMid,
            calendarBlockBg: sQuiet,
            calendarBlockBorder: borderMid,
            isDark: true,
            zeffyLogoVariant: "dark",
            footerBg: sQuiet,
            footerText: tModerate,
            footerStrong: tIntense,
        };
    }
    const canvasColor = dull ? hex((0, colors_1.hsl)(0, 0, 96)) : sQuiet;
    return {
        tIntense,
        tModerate,
        tBrand,
        tQuiet,
        tSupershy,
        tReverse,
        tError: "#ed4a55",
        sIntense,
        sModerate,
        sQuiet,
        sSupershy,
        sReverse,
        shIntense,
        shModerate,
        shQuiet,
        bBrand,
        bIntense,
        bModerate,
        bQuiet,
        bSupershy,
        canvas: canvasColor,
        emailBg: sReverse,
        headerBg: dull ? hex((0, colors_1.hsl)(0, 0, 97)) : sSupershy,
        innerBg: dull ? hex((0, colors_1.hsl)(0, 0, 98)) : sSupershy,
        noteBg: dull ? hex((0, colors_1.hsl)(0, 0, 97)) : sSupershy,
        orderBg: dull ? hex((0, colors_1.hsl)(0, 0, 95)) : sQuiet,
        ctaBg: dull ? tIntense : sIntense,
        ctaBgHover: dull ? tModerate : shIntense,
        ctaText: tReverse,
        brandFill: dull ? tIntense : sIntense,
        brandFillText: tReverse,
        tOrderNumber: tQuiet,
        bSecondaryCta: bQuiet,
        secondaryCtaBg: sReverse,
        secondaryCtaBorder: bQuiet,
        secondaryCtaText: tBrand,
        calendarBlockBg: sReverse,
        calendarBlockBorder: bModerate,
        isDark: false,
        zeffyLogoVariant: "light",
        footerBg: "#F5F7FA",
        footerText: "#0F0E5B",
        footerStrong: "#0A093D",
    };
}
